(function () {
  if (window.__cartRecSaleFlagInit) return;
  window.__cartRecSaleFlagInit = true;

  var collectionProductIds = {};
  var collectionsReady = null;
  var config = null;

  function shopifyRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function getConfig() {
    var el = document.querySelector('.cart-recommendation-sale-flag-config');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function loadCollectionProductIds(handle) {
    if (collectionProductIds[handle]) {
      return Promise.resolve(collectionProductIds[handle]);
    }

    var ids = new Set();
    var page = 1;
    var root = shopifyRoot();

    function fetchPage() {
      var url =
        root +
        'collections/' +
        encodeURIComponent(handle) +
        '/products.json?limit=250&page=' +
        page;

      return fetch(url)
        .then(function (res) {
          return res.json();
        })
        .then(function (data) {
          if (!data.products || !data.products.length) {
            return ids;
          }

          for (var i = 0; i < data.products.length; i++) {
            ids.add(String(data.products[i].id));
          }

          if (data.products.length < 250) {
            return ids;
          }

          page++;
          return fetchPage();
        });
    }

    return fetchPage()
      .then(function (set) {
        collectionProductIds[handle] = set;
        return set;
      })
      .catch(function () {
        collectionProductIds[handle] = new Set();
        return collectionProductIds[handle];
      });
  }

  function preloadCollections(tierConfig) {
    var handles = [];
    var seen = {};

    for (var i = 0; i < tierConfig.tiers.length; i++) {
      var handle = tierConfig.tiers[i].collectionHandle;
      if (handle && !seen[handle]) {
        seen[handle] = true;
        handles.push(handle);
      }
    }

    return Promise.all(handles.map(loadCollectionProductIds));
  }

  function messageForProduct(productId) {
    if (!config || !config.tiers) return '';

    var id = String(productId);

    for (var i = 0; i < config.tiers.length; i++) {
      var tier = config.tiers[i];
      if (!tier.message || !tier.collectionHandle) continue;

      var productIds = collectionProductIds[tier.collectionHandle];
      if (productIds && productIds.has(id)) {
        return tier.message;
      }
    }

    return '';
  }

  function hydrateCard(card) {
    var product = card.product;
    if (!product) return;

    var node = card.querySelector('.js-cart-rec-sale-flag');
    if (!node) return;

    var productId = String(product.id);
    if (node.getAttribute('data-product-id') === productId) return;

    var msg = messageForProduct(product.id);

    if (msg) {
      node.textContent = msg;
      node.classList.add('summer-sale-flag-custom', 'summer-sale-flag--visible');
      node.hidden = false;
      node.removeAttribute('hidden');
    } else {
      node.textContent = '';
      node.classList.remove('summer-sale-flag--visible');
      node.hidden = true;
      node.setAttribute('hidden', '');
    }

    node.setAttribute('data-product-id', productId);
  }

  function processContainer(container, observer) {
    if (observer) observer.disconnect();

    collectionsReady.then(function () {
      var cards = container.querySelectorAll('product-card, product-card-mini');
      for (var i = 0; i < cards.length; i++) {
        hydrateCard(cards[i]);
      }
      if (observer) {
        observer.observe(container, { childList: true, subtree: true });
      }
    });
  }

  function watch(container) {
    var observer = new MutationObserver(function () {
      processContainer(container, observer);
    });
    processContainer(container, observer);
    observer.observe(container, { childList: true, subtree: true });
  }

  function init() {
    var containers = document.querySelectorAll(
      'cart-recommendations [cart-recommendations-content]'
    );
    for (var i = 0; i < containers.length; i++) {
      watch(containers[i]);
    }
  }

  config = getConfig();
  if (!config || !config.enabled || !Array.isArray(config.tiers) || !config.tiers.length) {
    return;
  }

  collectionsReady = preloadCollections(config);

  function scheduleInit() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  }

  scheduleInit();

  // Re-check when cart recommendation cards finish client-side render
  document.addEventListener('product-card:rendered', function (event) {
    var card = event.target;
    if (!card || !card.closest('cart-recommendations')) return;
    collectionsReady.then(function () {
      hydrateCard(card);
    });
  });
})();
